import {
  EDIT_Terminal_Failed, EDIT_Terminal_Loading, EDIT_Terminal_Success, EDIT_Terminal_Reset
} from "../types";

const initialState = {
  loading: false,
  error: null,
  status: null,
};

export const editTerminalReducer = (
  state = initialState,
  action: { type: any; loading: any; status: any; error: any }
) => {
  switch (action.type) {
    case EDIT_Terminal_Loading:
      return {
        ...state,
        loading: action.loading,
      };
    case EDIT_Terminal_Success:
      return {
        ...state,
        loading: false,
        status: action.status,
        error: null,
      };
    case EDIT_Terminal_Failed:
      return {
        ...state,
        loading: false,
        status: null,
        error: action.error,
      };
    case EDIT_Terminal_Reset:
      return initialState;
    default:
      return state;
  }
};
